import type { RootState } from 'js/src/libs/RootState';

export function getColorGradingFilters(state: RootState) {
    return state.colorGrading.colorGradingFilters;
}

export function getColorGradingFilterFromUrl(state: RootState, textureUrl: string) {
    return state.colorGrading.colorGradingFilters.find(
        (filter) => filter.texture_url === textureUrl,
    );
}
